import { Clipboard, Platform } from 'react-native'

/**
 * Clipboard write for the dev capture log, with no new dependency.
 *
 * `expo-clipboard` is the supported route, but it is a native module: adding it
 * would force a dev-client rebuild, and this only backs a debug button. React
 * Native's core `Clipboard` is deprecated yet still shipped in 0.81 and works
 * on device; the web build goes through `navigator.clipboard` instead, since
 * react-native-web is not guaranteed to carry the deprecated export.
 *
 * Swap this for `expo-clipboard` if anything user-facing ever needs to copy.
 */
export const copyText = async (text: string): Promise<boolean> => {
  try {
    if (Platform.OS === 'web') {
      await navigator.clipboard.writeText(text)
      return true
    }
    Clipboard.setString(text)
    return true
  } catch {
    return false
  }
}
